import { motion } from 'framer-motion';
import styled from 'styled-components';

// className="fixed inset-0 z-[1000] grid place-items-center bg-black"
export const SpinnerWrapper = styled(motion.div)`
  position: absolute;
  inset: 0;
  z-index: 1;
  display: grid;
  place-items: center;
  padding-bottom: 20px;
  background-color: rgba(0, 0, 0, 0.7);
`;
